import React, {useContext} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import {
    CircularProgress,
    Divider,
    Icon, IconButton,
    ListItem, ListItemIcon,
    ListItemSecondaryAction,
    ListItemText, MenuItem,
    TextField,
} from "@material-ui/core";
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import {Cookies} from "react-cookie";
import {makeStyles} from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import countryList from 'react-select-country-list'
import {CartContext, MyContext} from "./MainPage";

let hotelmap=new Map();
hotelmap.set("hgrez","https://gondola.ozsnow.com");
hotelmap.set("hmrez", "https://madarao.ozsnow.com");
hotelmap.set("rqrez","https://reavers.ozsnow.com");
hotelmap.set("olrez","https://owashi.ozsnow.com");
hotelmap.set("svrez","https://snowyvalley.ozsnow.com");


const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
}));

function valid_credit_card(value) {
    // Accept only digits, dashes or spaces
    // if (/[^0-9-\s]+/.test(value)) return false;
    if (/[^0-9-]+/.test(value)) return false;

    // The Luhn Algorithm. It's so pretty.
    let nCheck = 0, bEven = false;
    value = value.replace(/\D/g, "");

    for (var n = value.length - 1; n >= 0; n--) {
        var cDigit = value.charAt(n),
            nDigit = parseInt(cDigit, 10);

        if (bEven && (nDigit *= 2) > 9) nDigit -= 9;

        nCheck += nDigit;
        bEven = !bEven;
    }

    return (nCheck % 10) == 0;
}

function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export default function CheckOutDialog(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(props.open);
    const [cart, setCart] = React.useState(props.cart);
    const [checkOut, setCheckOut] = React.useState(false);
    const [firstname, setFirstname] = React.useState("");
    const [surname, setSurname] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [phone, setPhone] = React.useState("");
    const [creditNum, setCreditNum] = React.useState("");
    const [nameOnCard, setNameOnCard] = React.useState("");
    const [expryMonth, setExpryMonth] = React.useState(new Date().getMonth()<9? "0"+(new Date().getMonth()+1):(new Date().getMonth()+1).toString());
    const [expryYear, setExpryYear] = React.useState(new Date().getFullYear());
    const [loading, setLoading]=React.useState("none");
    const [address, setAddress] = React.useState("");
    const [city, setCity] = React.useState("");
    const [state, setState] = React.useState("");
    const [country, setCountry] = React.useState("");
    const [postcode,setPostCode]=React.useState("");
    const [agreeToTerms, setAgreeToTerms] = React.useState(false);
    const myContext = useContext(MyContext);
    const options = countryList().getData();
    let total = 0;
    const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl)
    const currency=params.get('currency');
    const hotelname = params.get("hotel");

    let hotelterm=new Map();
    hotelterm.set("hgrez","https://skihirehakuba.com/terms-and-conditions/");
    hotelterm.set("hmrez", "https://skihiremadarao.com/index.php/terms-and-conditions/");
    hotelterm.set("rqrez","https://skirentalniseko.com/terms-conditions/");
    hotelterm.set("olrez","https://skirentalniseko.com/terms-conditions/");
    hotelterm.set("svrez","https://skirentalniseko.com/terms-conditions/");


    // const termlink = "https://skirentalniseko.com/terms-conditions/";
    const termlink = hotelterm.get(hotelname);

    var duration_days = 0;
    for (let i = 0; i < props.cart.length; i++) {
        total += props.cart[i].price * props.cart[i].itemNum;
        duration_days = props.cart[i].duration;
    }

    const [totCost, setTotCost] = React.useState(total);
    const cookies = new Cookies();
    const handleClose = () => {
        setOpen(false);
        props.setOpen(false);
    };
    const changeHandler = event => {
        setCountry(event.target.value);
    }

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
            >

                <DialogTitle id="alert-dialog-title">{checkOut ? "Check out" : "Shopping Cart"}</DialogTitle>
                {
                    checkOut ?
                        <DialogContent>
                            <div className={classes.root}>
                                <TextField
                                    id="First Name"
                                    label="First Name"
                                    required={true}
                                    value={firstname}
                                    onChange={(event) => {
                                        setFirstname(event.target.value)
                                    }}
                                    helperText="Please Enter your first name"
                                ></TextField>
                                <TextField
                                    id="Last Name"
                                    label="Last Name"
                                    required={true}
                                    value={surname}
                                    onChange={(event) => {
                                        setSurname(event.target.value)
                                    }}
                                    helperText="Please Enter your Last name"
                                ></TextField>
                                <TextField
                                    id="Email"
                                    label="Email"
                                    required={true}
                                    value={email}
                                    onChange={(event) => {
                                        setEmail(event.target.value)
                                    }}
                                    helperText="Please Enter Email"
                                ></TextField>
                                <TextField
                                    id="Phone"
                                    label="Phone"
                                    required={true}
                                    value={phone}
                                    onChange={(event) => {
                                        setPhone(event.target.value)
                                    }}
                                    helperText="Please Enter your phone number"
                                ></TextField>
                                <Divider/>
                                <h3 color="secondary">Total { currency+" " + totCost + " - "+ (isNaN(props.discount) ? "0" : Number.parseInt(props.discount)) + "% discount" + " = " + currency+" " + (totCost*(1-(isNaN(props.discount)? 0: Number.parseInt(props.discount))*0.01)).toFixed(2)} </h3>
                                <TextField
                                    id="cardnumber"
                                    label="Credit Cart Number"
                                    inputProps={{minlength:16}}
                                    required={true}
                                    value={creditNum}
                                    onChange={(event) => {
                                        setCreditNum(event.target.value)
                                    }}
                                    helperText="Please Enter your Credit Cart Number"
                                ></TextField>
                                <TextField
                                    id="card_name"
                                    label="Name on the card"
                                    required={true}
                                    value={nameOnCard}
                                    onChange={(event) => {
                                        setNameOnCard(event.target.value)
                                    }}
                                    helperText="Please Enter Name on the card"
                                ></TextField>
                                <TextField
                                    id="cc-exp-month"
                                    label="Expiry Month"
                                    required={true}
                                    type="number"
                                    select

                                    inputProps={{min: 1, max:12}}
                                    value={expryMonth}
                                    onChange={(event) => {
                                        setExpryMonth(event.target.value)
                                    }}
                                    helperText="Please Enter The Expiry Month (1~12)"
                                >
                                    <MenuItem key={"01"} value={"01"}>
                                        01
                                    </MenuItem>
                                    <MenuItem key={"02"} value={"02"}>
                                        {"02"}
                                    </MenuItem>
                                    <MenuItem key={"03"} value={"03"}>
                                        {"03"}
                                    </MenuItem>
                                    <MenuItem key={"04"} value={"04"}>
                                        {"04"}
                                    </MenuItem>
                                    <MenuItem key={"05"} value={"05"}>
                                        {"05"}
                                    </MenuItem>
                                    <MenuItem key={"06"} value={"06"}>
                                        {"06"}
                                    </MenuItem>
                                    <MenuItem key={"07"} value={"07"}>
                                        {"07"}
                                    </MenuItem>
                                    <MenuItem key={"08"} value={"08"}>
                                        {"08"}
                                    </MenuItem>
                                    <MenuItem key={"09"} value={"09"}>
                                        {"09"}
                                    </MenuItem>
                                    <MenuItem key={"10"} value={"10"}>
                                        {"10"}
                                    </MenuItem>
                                    <MenuItem key={"11"} value={"11"}>
                                        {"11"}
                                    </MenuItem>
                                    <MenuItem key={"12"} value={"12"}>
                                        {"12"}
                                    </MenuItem>
                                </TextField>
                                <TextField
                                    id="cc-exp-year"
                                    label="Expiry Year"
                                    required={true}
                                    select
                                    type="number"
                                    value={expryYear}
                                    onChange={(event) => {
                                        setExpryYear(event.target.value)
                                    }}
                                    helperText="Please Enter The Expiry Year"
                                >
                                    <MenuItem key={new Date().getFullYear()} value={new Date().getFullYear()}>
                                        {new Date().getFullYear()}
                                    </MenuItem>
                                    <MenuItem key={new Date().getFullYear()+1} value={new Date().getFullYear()+1}>
                                        {new Date().getFullYear()+1}
                                    </MenuItem>
                                    <MenuItem key={new Date().getFullYear()+2} value={new Date().getFullYear()+2}>
                                        {new Date().getFullYear()+2}
                                    </MenuItem>
                                    <MenuItem key={new Date().getFullYear()+3} value={new Date().getFullYear()+3}>
                                        {new Date().getFullYear()+3}
                                    </MenuItem>
                                    <MenuItem key={new Date().getFullYear()+4} value={new Date().getFullYear()+4}>
                                        {new Date().getFullYear()+4}
                                    </MenuItem>
                                    <MenuItem key={new Date().getFullYear()+5} value={new Date().getFullYear()+5}>
                                        {new Date().getFullYear()+5}
                                    </MenuItem>
                                    <MenuItem key={new Date().getFullYear()+6} value={new Date().getFullYear()+6}>
                                        {new Date().getFullYear()+6}
                                    </MenuItem>
                                    <MenuItem key={new Date().getFullYear()+7} value={new Date().getFullYear()+7}>
                                        {new Date().getFullYear()+7}
                                    </MenuItem>
                                    <MenuItem key={new Date().getFullYear()+8} value={new Date().getFullYear()+8}>
                                        {new Date().getFullYear()+8}
                                    </MenuItem>
                                    <MenuItem key={new Date().getFullYear()+9} value={new Date().getFullYear()+9}>
                                        {new Date().getFullYear()+9}
                                    </MenuItem>
                                    <MenuItem key={new Date().getFullYear()+10} value={new Date().getFullYear()+10}>
                                        {new Date().getFullYear()+10}
                                    </MenuItem>
                                </TextField>

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={agreeToTerms}
                                            onChange={(event) => setAgreeToTerms(event.target.checked)}
                                            color="primary"
                                        />
                                    }
                                    label={
                                        <span>
            I agree to the{" "}
                                            <a href={termlink} target="_blank" rel="noopener noreferrer">
                Terms and Conditions
            </a>
        </span>
                                    }
                                />

                                <Divider/>
                                <h3 color="secondary">Additional Comments</h3>
                                <TextField
                                    id="address"
                                    label="Additional Comments"
                                    required={false}
                                    value={address}
                                    fullWidth={true}
                                    onChange={(event) => {
                                        setAddress(event.target.value)
                                    }}
                                    helperText="Please Enter Additional Comments"
                                    style={{width: "80%"}}
                                ></TextField>
                                {/*<TextField*/}
                                {/*    id="suburb"*/}
                                {/*    label="Suburb (City)"*/}
                                {/*    required={true}*/}
                                {/*    value={city}*/}
                                {/*    fullWidth={true}*/}
                                {/*    onChange={(event) => {*/}
                                {/*        setCity(event.target.value)*/}
                                {/*    }}*/}
                                {/*    helperText="Please Enter City of billing address"*/}
                                {/*    style={{width: "80%"}}*/}
                                {/*></TextField>*/}
                                {/*<TextField*/}
                                {/*    id="state"*/}
                                {/*    label="State"*/}
                                {/*    required={true}*/}
                                {/*    fullWidth={true}*/}
                                {/*    value={state}*/}
                                {/*    onChange={(event) => {*/}
                                {/*        setState(event.target.value)*/}
                                {/*    }}*/}
                                {/*    helperText="Please Enter State of billing address"*/}
                                {/*    style={{width: "80%"}}*/}
                                {/*></TextField>*/}
                                {/*<TextField*/}
                                {/*    id="postCode"*/}
                                {/*    label="Postcode"*/}
                                {/*    required={true}*/}
                                {/*    value={postcode}*/}
                                {/*    fullWidth={true}*/}
                                {/*    onChange={(event) => {*/}
                                {/*        setPostCode(event.target.value)*/}
                                {/*    }}*/}
                                {/*    helperText="Please Enter your Street address"*/}
                                {/*    style={{width: "80%"}}*/}
                                {/*></TextField>*/}
                                {/*<TextField*/}
                                {/*    select id="country" required={true} fullWidth={true} label="Country"*/}
                                {/*    helperText="Please select your country"*/}
                                {/*    value={country} onChange={changeHandler} defaultValue={options[0].value}*/}
                                {/*    style={{width: "80%"}}>*/}
                                {/*    {options.map((item, index) => <MenuItem key={item.value} value={item.value}>*/}
                                {/*        {item.label}*/}
                                {/*    </MenuItem>)}*/}
                                {/*</TextField>*/}
                            </div>
                        </DialogContent>
                        : <DialogContent>

                            {cart.length == 0 ? "Nothing added" : ""}
                            <List>
                                {cart.map((item, index) => {
                                        return (
                                            <ListItem button={true} divider={true}>
                                                {/*<ListItemIcon>*/}
                                                {/*    <Icon component={"span"}>{item.itemNum}</Icon>*/}
                                                {/*</ListItemIcon>*/}
                                                {/*<ListItemText primary={item.itemName + " - " + item.itemType + " \tx " + item.itemNum}*/}
                                                {/*              secondary={item.startDate + " ~ " + item.endDate + " --- " + item.duration+" day(s)"}/>*/}
                                                <ListItemText primary={item.itemName + " - " + item.itemType + " \tx " + item.itemNum}
                                                              secondary={
                                                                  <React.Fragment>
                                                                      {item.startDate + " ~ " + item.endDate + " --- " + item.duration+" day(s)"}
                                                                      <br></br>
                                                                      <Typography
                                                                          sx={{ display: 'inline'}}
                                                                          component="span"
                                                                          variant="h6"
                                                                          color="text.primary"
                                                                      >
                                                                          {currency + (item.price * item.itemNum)}
                                                                      </Typography>
                                                                  </React.Fragment>
                                                              }/>
                                                {/*<ListItemIcon>*/}
                                                {/*    <IconButton disabled={true}>{currency + (item.price * item.itemNum)}</IconButton>*/}
                                                {/*</ListItemIcon>*/}

                                                <ListItemSecondaryAction>
                                                    <IconButton size={'small'} onClick={() => {
                                                        let newCart = cart;
                                                        cookies.set("cartNum", parseInt(props.cartNum) - parseInt(newCart[index].itemNum), {maxAge: 60 * 60})
                                                        props.setCartNum(parseInt(props.cartNum) - parseInt(newCart[index].itemNum));
                                                        if (index > -1) {
                                                            newCart.splice(index, 1);
                                                        }
                                                        setCart(newCart);
                                                        props.setCart(newCart);
                                                        cookies.set("cart", newCart, {maxAge: 60 * 60})
                                                        setTotCost(totCost - item.price * item.itemNum)
                                                    }
                                                    }><DeleteForeverIcon color="secondary"/> </IconButton>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                        )
                                    }
                                )}
                            </List>
                            {<h3> Total Cost :  { currency+" " + totCost + " - "+ (isNaN(props.discount) ? "0" : Number.parseInt(props.discount)) + "% discount" + " = " + currency+" " + (totCost*(1-(isNaN(props.discount)? 0: Number.parseInt(props.discount))*0.01)).toFixed(2)}</h3>}
                        </DialogContent>}
                {
                    checkOut ? <DialogActions>
                        <Button variant={'contained'} onClick={() => {
                            setCheckOut(false)
                        }} color="secondary">
                            Back
                        </Button>
                        <Button type="button" variant={'contained'} color="primary"  onClick={() => {
                            myContext.setBool(false);
                            const windowUrl = window.location.search;
                            const params = new URLSearchParams(windowUrl)
                            const hotel=params.get('hotel');
                            const nameRegex = /[a-zA-Z]/;
                            if(email=="" || email==null || !validateEmail(email)){
                                alert ("Invalid email");
                                return;
                            } else if (firstname=="" || firstname==null || !nameRegex.test(firstname)){
                                alert ("Invalid firstname");
                                return;
                            } else if (surname=="" || surname==null || !nameRegex.test(surname)){
                                alert ("Invalid surname");
                                return;
                            } else if ( phone=="" || phone==null){
                                alert ("Invalid phone Number")
                                return;
                            }
                            if (!agreeToTerms) {
                                alert("You must agree to the Terms and Conditions before proceeding.");
                                return;
                            }

                                // else if (state=="" || firstname==null){
                            //     alert("Invalid state")
                            // } else if (city=="" || city==null){
                            //     alert("Invalid City/Suburb")
                            // }else if (country=="" || country==null){
                            //     alert("Invalid Country")
                            // } else if (address=="" || address==null){
                            //     alert("Invalid Address")
                            // }
                            else if (!valid_credit_card(creditNum) || creditNum.length<16 || creditNum == "" || creditNum==null){
                                alert ("Invalid credit card number (Amex not supported)");
                                return;
                            } else if (nameOnCard=="" || nameOnCard==null){
                                alert ("Invalid name on credit card");
                                return;
                            } else if((Number.parseInt(expryMonth)<(new Date().getMonth()+1)) && (Number.parseInt(expryYear)<=new Date().getFullYear())){
                                alert ("Expiration date cannot be previous date");
                                return;
                            } else if(Number.parseInt(expryMonth)){
                                setLoading("block");
                                const requestOptions = {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({
                                        items: cart,
                                        suburb:city,
                                        state:state,
                                        country:country,
                                        address:address,
                                        hotelCode:props.hotelCode,
                                        postcode:postcode,
                                        firstname: firstname,
                                        surname: surname,
                                        email: email,
                                        phone: phone,
                                        creditCardNumber: creditNum,
                                        nameOnCreditCard: nameOnCard,
                                        creditCardExpiryMonth: expryMonth,
                                        creditCardExpiryYear: expryYear.toString(),
                                    })
                                };
                                fetch(hotelmap.get(hotel)+'/hire/items/save', requestOptions)
                                    .then(response => {
                                       response.text().then((text)=>{
                                           setLoading("none");
                                           if(!isNaN(text)) {
                                               //alert("Your order number is "+ text);
                                               props.setCart([]);
                                               props.setCartNum(0);
                                               const cookies = new Cookies();
                                               cookies.remove('cart');
                                               cookies.remove('cartNum');
                                               setCheckOut(false);
                                               myContext.setText(text);
                                               myContext.setBool(true);
                                               handleClose();
                                           } else alert (text);
                                       })
                                    })
                            } else {
                                alert ("Invalid input")
                            }
                            myContext.setBool(true);
                        }}
                        >
                            Submit
                        </Button>
                        <CircularProgress style={{display:loading}} />
                    </DialogActions> : <DialogActions>
                        <Button variant={'contained'} onClick={handleClose} color="secondary">
                            Close
                        </Button>
                        <Button variant={'contained'} onClick={() => {
                            if (cart.length > 0 && duration_days > 0) setCheckOut(true);
                        }} color="primary" autoFocus>
                            Check Out
                        </Button>
                    </DialogActions>
                }

            </Dialog>
        </div>
    );
}